"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidErc1056 = exports.DIDPattern = exports.ethAddrPattern = void 0;
var __1 = require("..");
exports.ethAddrPattern = '0x[A-Fa-f0-9]{40}';
exports.DIDPattern = "^did:" + __1.Methods.Erc1056 + ":(" + exports.ethAddrPattern + ")$";
function isValidErc1056(did) {
    return new RegExp(exports.DIDPattern).test(did);
}
exports.isValidErc1056 = isValidErc1056;
//# sourceMappingURL=validation.js.map